import { createFileRoute } from "@tanstack/react-router";
import { PipelineEditPage } from "@client/components/doc-center/pipelines";

export const Route = createFileRoute("/_app/data-center/tmpl/new")({
  // ?modelId= 从资产工作台「为此图谱新建模板」进入：预绑该模型（26 号断点①）
  validateSearch: (search: Record<string, unknown>): { kind?: string; modelId?: string } => ({
    kind: typeof search.kind === "string" ? search.kind : undefined,
    modelId: typeof search.modelId === "string" ? search.modelId : undefined,
  }),
  component: PipelineNewRoute,
});

function PipelineNewRoute() {
  const { kind, modelId } = Route.useSearch();
  return <PipelineEditPage kind={kind} presetModelId={modelId} />;
}
